<template>

	<Outer>
		<div class="row lobby-article-list">

			<div class="col-xs-12">

				<div class="articles-body">
					<div class="text-center mb20" v-show="!pager.loading">
						<span class="f20">{{title}}</span>
					</div>
					<div v-for="article in pager.articles" class="mb10">

						<a href="javascript:void(0)" class="nb-a" @click.stop.prevent="article.click()">
							{{article.title}}
					</a>

						<span class="pull-right">
				{{article.releaseTime | simpleDate}}
			</span>

					</div>

					<div class="mt20">
						<NbPager :pager="pager" :callback="refresh"></NbPager>
					</div>


				</div>


			</div>


		</div>

	</Outer>

</template>

<script>
	import NbPager from '../../../common/widget/NbPager.vue'
	import Pager from  "../../../common/model/base/Pager"
	import Article from  "../../../common/model/article/Article"
	import Outer from "./Outer.vue";

	export default {
		data () {
			return {
				pager: new Pager(Article)

			}
		},
		computed: {
			topic(){
				return this.$route.meta.topic;
			},
			type(){
				return this.$store.state.route.params.type;
			},
			typeMap(){
				let type = this.$store.state.route.params.type;
				if (!type) {
					return null;
				} else if (type === "newses") {
					return {
						name: "新闻",
						value: "newses",
						style: "success"
					};
				} else {
					return Article.prototype.TypeMap[type.toUpperCase()];
				}

			},
			title(){
				if (this.typeMap) {
					return this.typeMap.name;
				} else {
					return "文章列表";
				}
			}
		},
		components: {
			NbPager,
			Outer
		},
		watch: {
			'$route' (to, from) {
				if (to.path !== from.path) {
					this.reset();
					this.refresh();
				}
			}
		},
		methods: {
			reset(){
				this.pager.page = 0;
				this.pager.pageSize = 10;
				this.pager.resetFilter();
				if (this.typeMap) {
					if (this.typeMap.value === "newses") {
						this.pager.setFilter("types", ["NEWS", "LINE_NEWS"]);
					} else {
						this.pager.setFilter("type", this.typeMap.value);
					}

				}
			},
			refresh(){

				this.pager.httpFastPage();
			}
		},
		mounted(){

			this.pager.enableHistory();
			this.reset();
			this.refresh();

		}
	}

</script>


<style lang="less" rel="stylesheet/less">

	.lobby-article-list {
		.articles-body {

			padding: 40px;
			background-color: white;
			-webkit-border-radius: 5px;
			-moz-border-radius: 5px;
			border-radius: 5px;

		}
	}


</style>






// WEBPACK FOOTER //
// List.vue?b55d9ffe